import { EditorComponent } from '@tinymce/tinymce-angular';

/**
 * Where the portal build copies TinyMCE (apps/portal/project.json assets glob).
 * Provided as TINYMCE_SCRIPT_SRC so the wrapper never falls back to Tiny Cloud,
 * which the EU Content-Security-Policy blocks.
 */
export const TINYMCE_SCRIPT_URL = '/assets/tinymce/tinymce.min.js';

/**
 * Port of the TinyMCE 4 settings that lived in CoreModule (angular-tinymce forRoot):
 *  - theme `modern` / skin `lightgray` no longer exist; TinyMCE 6 ships `silver` + `oxide`
 *    and resolves them relative to the script URL, so no theme_url/skin_url is needed.
 *  - `paste` is core since TinyMCE 5; `paste_as_text` is still an option.
 *  - `paste_data_images` defaults to true in TinyMCE 6 (the TinyMCE 4 paste plugin defaulted
 *    to false), so pasted screenshots became base64 <img> in the body; a large one exceeds
 *    Salesforce's EmailMessage.HtmlBody limit. Images go through the attachment uploader.
 *  - toolbar item `styleselect` was renamed `styles` in TinyMCE 6.
 *  - `promotion: false` hides the community-build upgrade banner (option exists since 6.4).
 */
export const TINYMCE_INIT: EditorComponent['init'] = {
  branding: false,
  promotion: false,
  menubar: false,
  statusbar: false,
  height: 205,
  plugins: 'code link lists',
  paste_as_text: true,
  paste_data_images: false,
  toolbar:
    'code | undo redo | styles | bold italic' +
    ' | alignleft aligncenter alignright alignjustify' +
    ' | numlist bullist outdent indent | link',
};
